<template>
  <div id="games-area" class="games-container row mx-0 justify-content-around">
    <div class="col-12 col-lg-11 px-1 px-lg-0 mx-auto">
      <div id="game-filters-content" v-if="selectedTab" class="col-12 px-0 row mx-0 justify-content-between">
        <div id="gameCategoryList"
             class="col-lg-12 games-categories-container px-0 mb-3 col-12">
          <div class="area-title-block" @click="needSelects && selectedTab? dropCategories() : ''">
            <h6 class="block-title py-2 px-2 px-lg-4 m-0" v-if="needSelects">
              <span v-if="selectedTab">{{selectedTab.name}}</span>
              <span  v-if="needSelects" class="category-caret-span mr-2 float-right">
                <i class="fa fa-caret-down category-caret"></i>
              </span>
            </h6>
          </div>
          <ul v-if="selectedTab"
            class="px-2 px-lg-0 game-categories-list row justify-content-start justify-content-sm-between mx-0">
            <li
              v-for="(tab, idx, index) in games"
              :id="idx"
              :key="idx"
              class="px-0 games-category"
              :class="[idx===currentTabIndex ? 'active' : '']"
              @click.prevent="changeTab(idx, tab)">
              <GameCategories
                :tab-name="tab.name"
                :isNew="tab.hasNewIcon"
                :icon="getIconForTab(idx, index)">
              </GameCategories>
            </li>
          </ul>

          <div v-else class="row justify-content-center w-100 mx-0 py-4">
          </div>
        </div>
        <HomeBonuses v-if="!needSelects" id="home"></HomeBonuses>
      </div>
    </div>

    <div class="col-12 col-lg-11 px-0 mx-auto games-list-container justify-content-around" v-if="selectedTab">
      <div class="col-12 search-block px-0">
        <b-form  class="search-form" autocomplete="off">
          <div class="col-12 px-0">
            <b-form-group class="mb-2">
              <input
                id="gameSearchInput"
                v-model="gamesSearchText"
                class="form-control main-input"
                placeholder="Поиск по играм"
                @paste="onPaste"
                @focus="onFocus"
                @focusout="onFocusOut"
                @cut="onCut"/>
              <!--<label for="gameSearchInput" class="p-0 m-0 wh-0 d-inline-block"></label>-->
              <span  @click.prevent="searchGamev2" class="searchButton btn-secondary btn">
                <i class="fas fa-search"></i>
              </span>
              <b-button name="removeButton"
                v-if="gamesSearchText"
                class="removeButton"
                @click.stop.prevent="gamesSearchText = '' , selectedTab=searchGamev2()">
                <i class="fa fa-remove"></i>
              </b-button>
            </b-form-group>
          </div>
        </b-form>
      </div>

      <div class="col-12 games px-0">
        <div v-if="selectedTab" class="game-tab">
          <div class="col-12 px-0 row mx-0 py-2 justify-content-between">
            <h5 v-if="selectedTab.name && !needSelects" class="col-12 col-lg-2 tab_category_name px-0 px-lg-1">
             Категория - {{ selectedTab.name }}
            </h5>
            <p
              v-if="selectedProviders.length"
              class="col-2 col-sm-3 col-md-3 col-xl-1 remove-all-filters px-0"
              @click="removeAllFilters">
              Очистить <span class="remove-filter-word pl-1">фильтр</span>
            </p>
          </div>
          <GamesTab
            :tab="selectedTab"
            :providers="selectedProviders"
            :category="selectedTab.name">
          </GamesTab>
        </div>

      </div>
      <HomeBonuses v-if="needSelects"></HomeBonuses>
    </div>

    <div v-else  class="row justify-content-center w-100  mx-0 py-3">
      <Loader></Loader>
    </div>
  </div>
</template>

<script>
import GameCategories from '@/components/games/filters/GameCategories'
import GamesTab from './GamesTab'
import HomeBonuses from '../main/HomeBonuses'
import Loader from '../Loader'

export default {
  name: 'Games',
  components: {
    GamesTab,
    GameCategories,
    HomeBonuses,
    Loader
  },
  data () {
    return {
      needSelects: false,
      tabs: {},
      selectedTab: null,
      currentTabName: 'Популярные',
      gamesSearchText: '',
      selectedProviders: [],
      currentTabIndex: '',
      providerSearchText: '',
      tabIcons: {
        favorites: {
          img: require('@/../public/images/icons/game_categories/crown.png'),
          type: 'png'
        },
        allGames: {
          img: require('@/../public/images/icons/game_categories/cubes.png'),
          type: 'png'
        },
        lastPlayed: {
          img: require('@/../public/images/icons/game_categories/balls.png'),
          type: 'png'
        },
        0: {
        img: require('@/../public/images/icons/game_categories/cards.png'),
        type: 'png'
        },
        1: {
        img: require('@/../public/images/icons/game_categories/jsckpot.png'),
        type: 'png'
        },
        2: {
        img: require('@/../public/images/icons/game_categories/fishka.png'),
        type: 'png'
        },
        3: {
        img: require('@/../public/images/icons/game_categories/bal.png'),
        type: 'png'
        },
        4: {
        img: require('@/../public/images/icons/game_categories/roulette.png'),
        type: 'png'
        },
        5: {
        img: require('@/../public/images/icons/game_categories/bal.png'),
        type: 'png'
        },
      },
      foundedGames: [],
      foundedProviders: [],
      scrolled: false
    }
  },
  computed: {
    isMobile () {
      return this.$_config.environment.mobile
    },

    games () {
      // if (!this.$store.getters.games.length) {
      //   this.$store.dispatch('fetchGames')
      // }
      const allGames = this.$store.getters.games
      let availableGames = null
      if (!allGames) {
        return null
      }
      availableGames = {}
      for (const tabKey in allGames) {
        // if (!allGames.hasOwnProperty(tabKey)) {
        //   continue
        // }
        const tabOptions = allGames[tabKey].opts

        if (
            (tabOptions.hasOwnProperty('android') && !tabOptions.android && this.$_config.isAndroid()) ||
            (tabOptions.hasOwnProperty('ios') && !tabOptions.ios && this.$_config.isIos()) ||
            (tabOptions.hasOwnProperty('desktop') && !tabOptions.desktop && !this.$_config.environment.mobile)
        ) {
          continue
        }

        availableGames[tabKey] = {
          hasNewIcon: allGames[tabKey].hasNewIcon ? allGames[tabKey].hasNewIcon : false,
          icon: allGames[tabKey].icon,
          name: allGames[tabKey].name,
          games: [],
          auth: !!allGames[tabKey].hasOwnProperty('need_auth'),
          role: allGames[tabKey].role ? allGames[tabKey].role : null,
          openAsFirstTab: allGames[tabKey].openAsFirstTab ? allGames[tabKey].openAsFirstTab : false,
        }

        for (const i in allGames[tabKey].games) {
          if (!allGames[tabKey].games.hasOwnProperty(i)) {
            continue
          }
          const game = allGames[tabKey].games[i]
          if (
              (game.hasOwnProperty('android') && !game.android && this.$_config.isAndroid()) ||
              (game.hasOwnProperty('ios') && !game.ios && this.$_config.isIos()) ||
              (game.hasOwnProperty('desktop') && !game.desktop && !this.$_config.environment.mobile) ||
              (game.picture === '')
          ) {
            continue
          }

          availableGames[tabKey].games.push(game)
        }
      }
      return availableGames
    },
    providers () {
      return this.$store.getters.providers
    },
    userData () {
      return this.$store.getters.userData
    }
  },
  watch: {
    games () {
      if (this.games) {
        this.selectedTab = this.games[(Object.keys(this.games)[0])]
      }
    },
    gamesSearchText (newVal, oldValue) {
      if (newVal !== '') {
        clearTimeout(this.searchTimeoutId)
        this.searchTimeoutId = setTimeout(() => {
          this.selectedTab = true
          this.searchGamev2()
        }, 800)
      } else if (oldValue !== '') {
        clearTimeout(this.searchTimeoutId)
        this.searchTimeoutId = setTimeout(() => {
          this.selectedTab = true
          this.searchGamev2()
        }, 800)
      } else {
        this.foundedGames = []
        if (typeof this.currentTabIndex === 'undefined' || this.currentTabIndex === '') {
          this.currentTabIndex = Object.keys(this.games)[2]
        }
        this.selectedTab = this.games[this.currentTabIndex]
      }
    },
    providerSearchText () {
      this.searchProvider()
    },
    userData(newVal) {
      if (newVal) {
        this.$store.dispatch('checkForAliveGame')
        this.$store.dispatch('checkUserFreeRoundNew')
      }
    }
  },
  mounted () {
    this.$store.dispatch('fetchGames')
    document.addEventListener('scroll', this.listenScrollEvent)
    const screenWidth = window.innerWidth
    if (screenWidth < 992) {
      this.needSelects = true
    }

    if (this.games) {

      if (typeof this.currentTabIndex === 'undefined' || this.currentTabIndex === '') {
        this.currentTabIndex = Object.keys(this.games)[2]
      }
      this.selectedTab = this.games[this.currentTabIndex]
    }

    if (this.providers.length) {
      this.foundedProviders = this.providers
    }
    const _this = this
    this.$root.$on('addGameToFavorites', function (value) {
      const allGames = _this.games
      for (const tabKey in allGames) {
        if (!allGames.hasOwnProperty(tabKey)) {
          continue
        }
        for (const i in allGames[tabKey].games) {
          if (!allGames[tabKey].games.hasOwnProperty(i)) {
            continue
          }
          const game = allGames[tabKey].games[i]
          if (!value.hasOwnProperty('unique_id') || !game.hasOwnProperty('unique_id')) {
            continue
          }
          if (game.unique_id === value.unique_id) {
            game.is_favorite = 1
          }
        }
      }
      _this.games.favorites.games.push(value)
    })

    this.$root.$on('removeGameFromFavorites', function (value) {
      const favTabGames = _this.games.favorites.games
      if (favTabGames && favTabGames.length) {
        for (const i in favTabGames) {
          if (!favTabGames.hasOwnProperty(i) || !favTabGames[i].unique_id || !value.hasOwnProperty('unique_id')) {
            continue
          }
          if (favTabGames[i].unique_id === value.unique_id) {
            favTabGames.splice(i, 1)
          }
        }
      }
      const allGames = _this.games
      for (const tabKey in allGames) {
        if (!allGames.hasOwnProperty(tabKey)) {
          continue
        }
        for (const i in allGames[tabKey].games) {
          if (!allGames[tabKey].games.hasOwnProperty(i)) {
            continue
          }
          const game = allGames[tabKey].games[i]
          if (!value.hasOwnProperty('unique_id')) {
            continue
          }
          if (game.hasOwnProperty('unique_id') && game.unique_id === value.unique_id) {
            game.is_favorite = 0
            if (tabKey === 'favorites') {
              allGames[tabKey].games.splice(i, 1)
            }
          }
        }
      }
    })
  },
  updated () {
    if (this.games && this.gamesSearchText === '' && !this.selectedProviders.length) {
      if (typeof this.currentTabIndex === 'undefined' || this.currentTabIndex === '') {
        this.currentTabIndex = Object.keys(this.games)[2]
      }
      this.selectedTab = this.games[this.currentTabIndex]
    }
    if (this.providers.length && this.providerSearchText === '') {
      this.foundedProviders = this.providers
    }
  },
  methods: {
    providerInfo (id) {
      const providers = this.providers
      for (const provider of providers) {
        if (provider.id === id) {
          return provider
        }
      }
      return null
    },
    dropCategories () {
      const mainArea = document.getElementById('gameCategoryList')
      const providers = document.getElementById('gameProviderList')
      if (mainArea.classList.contains('dropped')) {
        mainArea.classList.remove('dropped')
      } else {
        mainArea.classList.add('dropped')
      }
      if (providers) {
        providers.classList.remove('dropped')
      }
    },
    dropProviders () {
      const mainArea = document.getElementById('gameProviderList')
      const categories = document.getElementById('gameCategoryList')
      if (mainArea) {
        if (mainArea.classList.contains('dropped')) {
          mainArea.classList.remove('dropped')
        } else {
          mainArea.classList.add('dropped')
        }
      }

      if (categories) {
        categories.classList.remove('dropped')
      }
    },
    onPaste (event) {
      const pasteText = (event.clipboardData || window.clipboardData).getData('text')
      if (pasteText !== '') {
        this.searchGamev2()
      }
      return true
    },
    onCut () {
      const cutText = document.getSelection().toString()
      if (cutText !== '') {
        this.searchGamev2()
      }
      return true
    },
    onFocus() {
        let elem = document.getElementById("gameSearchInput");
        elem.placeholder =  "Введите имя игры"
    },
    onFocusOut() {
      let elem = document.getElementById("gameSearchInput");
      elem.placeholder =  "Поиск по играм"
    },
    getIconForTab (idx, index) {
      if (this.tabIcons[idx]) {
        return this.tabIcons[idx]
      }
      const size = (Object.keys(this.tabIcons)).length
      if (index > size - 4) {
        index %= size - 3
      }

      return this.tabIcons[index]
    },
    changeTab (tabId, tabContent) {
      if (!this.$store.getters.userData && tabContent.auth) {
        this.$root.$emit('bv::show::modal', 'loginModal')
        return this.$root.$emit('reasonToLogin', 'Категория доступна только авторизованным клиентам')
      }

      const allTabs = document.querySelectorAll('.game-categories-list li')
      allTabs.forEach(function (item) {
        item.classList.remove('active')
      })
      const activeTab = document.getElementById(tabId)
      activeTab.classList.add('active')

      if (this.games[tabId].games.length == 0) {
        this.$store.dispatch('fetchGamesByProvidersv2', tabId)
        this.currentTabIndex = tabId
        return this.searchGamev2()
      } else {
        this.currentTabIndex = tabId
        return this.searchGamev2()
      }


      // this.currentTabIndex = tabId
      // if (this.needSelects) {
      //   this.dropCategories()
      // }
      // this.selectedTab = tabContent
      //
      // return this.searchGame()
    },
    checkProviderSelected (providerId) {
      return this.selectedProviders.indexOf(providerId) === -1
    },


    searchGamev2() {
      if (this.gamesSearchText === '') {
        return true
      }
      const providers = this.selectedProviders
      const games = []
      const gameUniqueIds = []
      this.foundedGames = []
      const searchInGames = this.games[this.currentTabIndex].games
      for (const i in searchInGames) {
        if (!searchInGames.hasOwnProperty(i)) {
          continue
        }
        const cg = searchInGames[i]
        const name = cg.name.toLowerCase()
        // const desc = cg.description.toLowerCase()
        const gameProvider = cg.provider

        if (this.gamesSearchText === '') {
          if (providers.length > 0) {
            if (providers.indexOf(gameProvider) !== -1) {
              if (!cg.hasOwnProperty('unique_id')) {
                continue
              }
              if (gameUniqueIds.indexOf(cg.unique_id) === -1) {
                games.push(cg)
                gameUniqueIds.push(cg.unique_id)
              }
            }
          }
        } else {

          if (name.indexOf(this.gamesSearchText.toLowerCase()) !== -1) {
              // || desc.indexOf(this.gamesSearchText.toLowerCase()) !== -1) {
            if (providers.length > 0) {
              if (providers.indexOf(gameProvider) !== -1) {
                if (!cg.hasOwnProperty('unique_id')) {
                  continue
                }
                if (gameUniqueIds.indexOf(cg.unique_id) === -1) {
                  games.push(cg)
                  gameUniqueIds.push(cg.unique_id)
                }
              }
            } else {
              // console.log(name)
              // console.log(cg)

              // if (!cg.hasOwnProperty('unique_id')) {
              //   continue
              // }



              // if (gameUniqueIds.indexOf(cg.unique_id) === -1) {
              games.push(cg)
              gameUniqueIds.push(cg.unique_id)
              // }
            }
          }
        }
      }

      this.foundedGames = games

      let gamesFound = false
      if (games.length > 0) {
        gamesFound = true
      }
      this.selectedTab = {
        games: games,
        gamesFound: gamesFound,
        searchText: this.gamesSearchText,
        name: this.games[this.currentTabIndex].name
      }

      return true
    },

    // searchGame () {
    //   const providers = this.selectedProviders
    //
    //   if (this.gamesSearchText === '' && !providers.length) {
    //     this.foundedGames = []
    //     if (typeof this.currentTabIndex === 'undefined' || this.currentTabIndex === '') {
    //       this.currentTabIndex = Object.keys(this.games)[0]
    //     }
    //     this.selectedTab = this.games[this.currentTabIndex]
    //     return true
    //   }
    //   const games = []
    //   const gameUniqueIds = []
    //   this.foundedGames = []
    //   const searchInGames = this.games[this.currentTabIndex].games
    //   for (const i in searchInGames) {
    //     if (!searchInGames.hasOwnProperty(i)) {
    //       continue
    //     }
    //     const cg = searchInGames[i]
    //     const name = cg.name.toLowerCase()
    //     const desc = cg.description.toLowerCase()
    //     const gameProvider = cg.provider
    //
    //     if (this.gamesSearchText === '') {
    //       if (providers.length > 0) {
    //         if (providers.indexOf(gameProvider) !== -1) {
    //           if (!cg.hasOwnProperty('unique_id')) {
    //             continue
    //           }
    //           if (gameUniqueIds.indexOf(cg.unique_id) === -1) {
    //             games.push(cg)
    //             gameUniqueIds.push(cg.unique_id)
    //           }
    //         }
    //       }
    //     } else {
    //       if (name.indexOf(this.gamesSearchText.toLowerCase()) !== -1 ||
    //                         desc.indexOf(this.gamesSearchText.toLowerCase()) !== -1) {
    //         if (providers.length > 0) {
    //           if (providers.indexOf(gameProvider) !== -1) {
    //             if (!cg.hasOwnProperty('unique_id')) {
    //               continue
    //             }
    //             if (gameUniqueIds.indexOf(cg.unique_id) === -1) {
    //               games.push(cg)
    //               gameUniqueIds.push(cg.unique_id)
    //             }
    //           }
    //         } else {
    //           if (!cg.hasOwnProperty('unique_id')) {
    //             continue
    //           }
    //           if (gameUniqueIds.indexOf(cg.unique_id) === -1) {
    //             games.push(cg)
    //             gameUniqueIds.push(cg.unique_id)
    //           }
    //         }
    //       }
    //     }
    //   }
    //
    //   this.foundedGames = games
    //
    //   let gamesFound = false
    //   if (games.length > 0) {
    //     gamesFound = true
    //   }
    //   this.selectedTab = {
    //     games: games,
    //     gamesFound: gamesFound,
    //     searchText: this.gamesSearchText,
    //     name: this.games[this.currentTabIndex].name
    //   }
    //
    //   return true
    // },
    searchProvider () {
      if (this.providerSearchText === '') {
        this.foundedProviders = this.providers
        return false
      }
      const providers = []
      const allProviders = this.providers
      allProviders.forEach((provider) => {
        const name = provider.name.toLowerCase()
        if (name.indexOf(this.providerSearchText.toLowerCase()) !== -1) {
          providers.push(provider)
        }
      })

      this.foundedProviders = providers
      return false
    },
    selectProvider (providerId) {
      if (this.selectedProviders.indexOf(providerId) === -1) {
        this.selectedProviders.push(providerId)
      } else {
        this.selectedProviders = this.selectedProviders.filter((id) => {
          return id !== providerId
        })
      }
      return this.searchGamev2()
    },
    removeProvider (providerId) {
      this.selectedProviders = this.selectedProviders.filter((id) => {
        return id !== providerId
      })
      return this.searchGamev2()
    },
    removeAllFilters () {
      this.selectedProviders = []
    },
    activateLastTab () {
      if (this.games) {
        return this.games[this.currentTabIndex]
      }
      return false
    },
    listenScrollEvent () {
      // let parent = document.getElementById("games-area");
      // let elem = document.getElementById("game-filters-content");
      // let bonusElem = document.getElementById("home");
      // let viewportOffset = parent.getBoundingClientRect();
      // let top = viewportOffset.top;
      // let bottom = viewportOffset.bottom;
      // // let elemHeight = elem.offsetHeight;
      // let footer = document.getElementById("footer");
      // let footerHeight = footer.offsetHeight;
      // let windowHeight = window.outerHeight;
      // let diffVisibleFooter = windowHeight - footerHeight;
      // let elemBottom = elem.getBoundingClientRect().bottom;
      // if (top <= 10) {
      //     bonusElem.classList.add("d-none");
      //     elem.classList.add("filters-fixed","col-lg-4","col-xl-3","pr-2");
      // } else {
      //     bonusElem.classList.remove("d-none");
      //     elem.classList.remove("filters-fixed","col-lg-4","col-xl-3","pr-2");
      // }
    }
  }
}
</script>

<style>
  .game-providers-list{
    margin-bottom: 0;
  }
  .searchButton i,
  .removeButton i {
    padding: 6px 3px;
  }

  .searchButton, .removeButton {
    position: absolute;
    top: 0;
    color: white;
    border: none !important;
    border-radius: 0 !important;
    background-color: transparent !important;
  }
  .searchButton {
    right: 5px;
  }
  @media screen and (min-width: 1200px) {
    .games-categories-container{
      margin-top: -65px;
    }
  }
  @media screen and (max-width: 992px) {
    .games-provider{
      height: 40px !important;
    }
    .searchButton{
      right: 0;
    }
    .removeButton {
      left: 0;
    }
    .games-provider:hover .game-provider,
    .games-provider:focus .game-provider {
      box-shadow: unset;
    }
    #gameProviderList,#gameCategoryList{
      height: 34px;
      background-color: unset;
    }
    .area-title-block{
      outline: none !important;
      color:#ffffff;
      border-radius:5px;
      background-image: linear-gradient(45deg, rgb(4, 4, 4) 0%, rgb(0, 0, 0) 100%);
      background-origin: border-box;
      background-clip: padding-box, border-box;
      position: relative;
    }
    .area-title-block:after{
      position: absolute;
      content: " ";
      left: -3px;
      top: -3px;
      bottom: -3px;
      right: -3px;
      outline: none !important;
      border-radius:6px;
      background-position: 0 100%, 100% 100%;
      background-repeat: no-repeat;
      background-size:  1px 100%;
      border-top: 1px solid rgba(255,255,255,0.6);
      border-bottom: 1px solid rgba(255,255,255,0.6);
      background-image:  linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, #011e40 35%, #011e40 65%, rgba(255,255,255,0.6) 100%), linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, #011e40 35%,#011e40 65%, rgba(255,255,255,0.6) 100%);
    }
    #gameProviderList.dropped,
    #gameCategoryList.dropped{
      height: auto;
    }
    #gameProviderList .search-block,
    #gameProviderList .providers-area,
    #gameProviderList .game-providers-list{
      display: none;
    }
    #gameProviderList .remove-prov-filter{
      display: none;
    }
    #gameProviderList.dropped .provider-caret::before{
      content: "\f0d8";
    }
    #gameProviderList.dropped .game-providers-list{
      width: calc(100vw - 15px);
      z-index: 20;
      height: auto;
      max-height: 300px;
      overflow-y: auto;
      display: flex;
      background-color: #010101;
      top: 5px;
      position: relative;
      right: calc(100% + 20px);
      box-shadow: 0 -3px 3px 2px inset #151515;
      border-radius: 5px;
      background-image: linear-gradient(45deg, rgb(4, 4, 4) 0%, rgb(0, 0, 0) 100%);
      background-origin: border-box;
      background-clip: padding-box, border-box;
      margin-bottom: 0;
    }
    #gameProviderList.dropped .providers-area{
      display: flex;
      height: auto;
      max-height: 300px;
      overflow-y: auto;
      background-color: #333333;
    }

    #gameProviderList .game-provider{
      height: 50px;
      margin: 5px !important;
    }
    #gameProviderList .game-provider-icon{
      display: inline-block;
      margin: unset;
      width: 40px;
    }

    #gameCategoryList .game-categories-list{
      display: none;
    }
    #gameCategoryList.dropped .game-categories-list{
      margin-bottom: 0 !important;
      height: auto;
      max-height: 300px;
      overflow-y: auto;
      display: flex;
      background-color: #010101;
      width: calc(100vw - 15px);
      top: 3px;
      position: relative;
      z-index: 20;
      left: -3px;
      outline: none !important;
      border-radius:5px;
      background-image: linear-gradient(45deg, rgb(4, 4, 4) 0%, rgb(0, 0, 0) 100%);
      background-origin: border-box;
      background-clip: padding-box, border-box;
    }
    #gameCategoryList .game-category{
      display: none;
    }
    #gameCategoryList.dropped .game-category {
      height: 100%;
      color: #ffffff;
      cursor: pointer;
      display: flex;
    }
    #gameCategoryList.dropped .category-caret::before {
      content: "\f0d8";
    }

    #gameCategoryList.dropped .games-category {
      height: 60px;
    }
    #gameCategoryList.dropped .game-category-icon {
      width: 20px;
      height: 20px;
      display: inline-block;
      opacity: 0.5;
      margin-right: auto;
    }
    #gameCategoryList.dropped .category-title{
      width: unset !important;
      line-height: 30px;
      max-height: 35px;
      overflow: hidden;
			margin: auto 0;
    }
    #gameCategoryList.dropped .game-category-content{
      height:40px;
      width:40px;
      margin: auto 0 !important;
    }
    .game-categories-list{
      height: 30px;
      overflow: hidden;
    }
    .games-category,.games-provider{
      height: 40px;
      width: 50% !important;
      min-width: 50%;
    }
    .category-inside{
      height: 32px;
      width: 32px;
    }
    .remove-all-filters{
      width: 100%;
      float: none;
      height: 40px;
      line-height: 25px;
      max-width: 100%;
      text-align: left;
      padding: 0;
      margin: 0;
      display: flex;
    }
    .selected-providers-list{
      width: 90%;
      max-width: 90%;
    }
    .tab_category_name{
      max-width: 35%;
    }
    .game-item .game-img {
      height: 150px;
      max-height: 150px;
    }
    .game-info {
      top: 100%;
    }
  }
  @media screen and (max-width: 450px) {
    .games-category,.games-provider{
      width: 100%;
    }
    .game-item .game-img {
      height: 115px;
    }
    .selected-providers-list{
      display: block;
      height: auto;
      overflow-x: unset;
    }
    .remove-all-filters{
      display: none;
    }
    .game-provider-name {
      max-width: 110px;
      display: inline-flex;
      overflow-x: hidden;
      padding-left: 3px;
    }
  }
</style>
<style scoped>
  .games-provider{
    min-width: 10%;
    height: 35px;
    width: 13%;
  }
  .remove-all-filters{
    text-align: right;
    font-size: 15px;
    cursor: pointer;
  }
  .selected-providers-list::-webkit-scrollbar {
    width: 10px;
    height: 5px;
    background-color: #ffffff;
    border-radius: 5px;
  }
  .selected-providers-list::-webkit-scrollbar-thumb {
    background-color: #2a2a2a;
    border-radius: 5px;
    width: 4px !important;
  }
  .selected-providers-list::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.3);
    background-color: #F5F5F5;

    width: 50px;
  }

  .selected-provider-name .remove-prov-filter{
    right: -5px !important;
    top: -3px;
    width: 15px;
    height: 15px;

  }
  .selected-provider-name:hover .remove-prov-filter{
    display: inline-block;
    color:#ee2126
  }
  .selected-provider-name:hover{
    color:#ee2126
  }
  .remove-prov-filter{
    display: none;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 18px;
    height: 18px;
    border: none;
    color: #7d7d7d;
    border-radius: 50%;
    text-align: center;
    line-height: 10px;
    cursor: pointer;
    z-index: 1;
  }
  .remove-prov-filter>i{
    font-weight: 100 !important;
    font-size: 14px;
  }
  .tab_category_name,.filter-prov-title{
    font-size: 15px;
  }
  .selected-providers-list{
    margin-bottom: 0 !important;
    text-align: left;
    padding: 0 0 0 10px;
    background-color: transparent;
    font-size: 16px;
    overflow-x: auto;
    overflow-y: hidden;
    display: inline-flex;
  }
  .selected-provider-name{
    position: relative;
    font-size: 15px;
    font-style: normal;
    color: #989898;
    padding: 0 10px 0 0 ;
    display: inline-block;
    user-select: none;
    cursor: pointer;
    text-decoration: underline;
    margin-right: 10px;
  }
</style>
